import { useState } from "react";
import { message } from "antd";
import useRequest from "./useRequest";

const useAutomaticEmails = () => {
  const [configs, setConfigs] = useState([]);
  const [recipients, setRecipients] = useState([]);
  const [reportTypes, setReportTypes] = useState([]);
  const [loading, setLoading] = useState({
    get: false,
    post: false,
    put: false,
    delete: false,
  });

  const { request } = useRequest();

  // Obtener lista de configuraciones
  async function getConfigs() {
    setLoading((prev) => ({ ...prev, get: true }));
    return await request(
      "GET",
      "passengers/automatic-email-configs/",
      (data) => {
        setConfigs(data.results || data);
        setLoading((prev) => ({ ...prev, get: false }));
        return data;
      },
      (error) => {
        setLoading((prev) => ({ ...prev, get: false }));
        message.error("Error al cargar configuraciones");
        return error;
      }
    );
  }

  // Obtener lista de usuarios disponibles como destinatarios
  async function getRecipients() {
    return await request(
      "GET",
      "passengers/automatic-email-configs/recipients/",
      (data) => {
        setRecipients(data);
        return data;
      },
      (error) => {
        message.error("Error al cargar destinatarios");
        return error;
      }
    );
  }

  // Obtener tipos de reportes disponibles
  async function getReportTypes() {
    return await request(
      "GET",
      "passengers/automatic-email-configs/report-types/",
      (data) => {
        setReportTypes(data);
        return data;
      },
      (error) => {
        return error;
      }
    );
  }

  // Crear nueva configuración
  async function createConfig(data) {
    setLoading((prev) => ({ ...prev, post: true }));
    return await request(
      "POST",
      "passengers/automatic-email-configs/",
      (response) => {
        setLoading((prev) => ({ ...prev, post: false }));
        message.success("Configuración creada exitosamente");
        return response;
      },
      (error) => {
        setLoading((prev) => ({ ...prev, post: false }));
        message.error("Error al crear configuración");
        return error;
      },
      data
    );
  }

  // Actualizar configuración
  async function updateConfig(id, data) {
    setLoading((prev) => ({ ...prev, put: true }));
    return await request(
      "PUT",
      `passengers/automatic-email-configs/${id}/`,
      (response) => {
        setLoading((prev) => ({ ...prev, put: false }));
        message.success("Configuración actualizada");
        return response;
      },
      (error) => {
        setLoading((prev) => ({ ...prev, put: false }));
        message.error("Error al actualizar");
        return error;
      },
      data
    );
  }

  // Eliminar configuración
  async function deleteConfig(id) {
    setLoading((prev) => ({ ...prev, delete: true }));
    return await request(
      "DELETE",
      `passengers/automatic-email-configs/${id}/`,
      (response) => {
        setLoading((prev) => ({ ...prev, delete: false }));
        message.success("Configuración eliminada");
        return response;
      },
      (error) => {
        setLoading((prev) => ({ ...prev, delete: false }));
        message.error("Error al eliminar");
        return error;
      }
    );
  }

  // Enviar reporte ahora (manual)
  async function sendNow(id, reportDate = null) {
    return await request(
      "POST",
      `passengers/automatic-email-configs/${id}/send-now/`,
      (response) => {
        message.success("Envío programado correctamente");
        return response;
      },
      (error) => {
        message.error("Error al programar envío");
        return error;
      },
      reportDate ? { report_date: reportDate } : {}
    );
  }

  return {
    configs,
    recipients,
    reportTypes,
    loading,
    getConfigs,
    getRecipients,
    getReportTypes,
    createConfig,
    updateConfig,
    deleteConfig,
    sendNow,
  };
};

export default useAutomaticEmails;
